module.exports = __webpack_public_path__ + "img/c02_unitchariotarcher_Normal_ua.2a08a82b.webp";